import type { SocialLink } from '~/types'

export default defineAppConfig({
  title: 'Atlas Creative',
  social: [
    {
      label: 'X',
      href: 'https://x.com/AtlasCreativeFN',
      icon: 'x'
    },
    {
      label: 'TikTok',
      href: 'https://www.tiktok.com/@atlascreativefn',
      icon: 'tik-tok'
    },
    {
      label: 'LinkedIn',
      href: 'https://www.linkedin.com/company/atlascreative/',
      icon: 'linkedin'
    },
    {
      label: 'Discord',
      href: 'https://discord.com/invite/atlas-creative-516619453887414284',
      icon: 'discord'
    }
  ],
  ui: {
    enable3D: true,
    enableFluidThree: false
  }
})

declare module '@nuxt/schema' {
  interface AppConfigInput {
    title?: string
    layer?: {
      name?: string
    }
    social: SocialLink[]
    ui?: {
      enable3D?: boolean
    }
  }
}
